import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {
  transform(phoneValue: string): string {
    if (!phoneValue) {
      return '';
    }
    if (phoneValue.startsWith('webcall-client-')) {
      return phoneValue;
    }
    if (phoneValue.startsWith('webcall-')) {
      return 'webcall';
    }
    if (!phoneValue.startsWith('+')) {
      return phoneValue;
    }
    const phoneNumber = parsePhoneNumber(phoneValue);
    return phoneNumber.formatInternational();
  }
}
